import { easeCurves } from "../../motion/eases";
export var DURATION = 300;
export var transitionTypes = {
  /** Used for toggling an individual panel */
  toggle: {
    hide: function hide() {
      return {
        keyframes: [{
          opacity: 1
        }, {
          opacity: 0
        }],
        options: {
          delay: 0,
          duration: DURATION,
          easing: easeCurves.easeOutQuint
        }
      };
    },
    show: function show() {
      return {
        keyframes: [{
          opacity: 0
        }, {
          opacity: 1
        }],
        options: {
          delay: 50,
          duration: DURATION,
          easing: easeCurves.easeOutQuint
        }
      };
    }
  },

  /** Page forward */
  page: {
    hide: function hide() {
      return {
        keyframes: [{
          opacity: 1
        }, {
          opacity: 0
        }],
        options: {
          duration: 250,
          easing: 'cubic-bezier(0.5, 0, 0, 1)'
        }
      };
    },
    show: function show() {
      return {
        keyframes: [{
          opacity: 0
        }, {
          opacity: 1
        }],
        options: {
          duration: 250,
          easing: 'cubic-bezier(0.5, 0, 0, 1)'
        }
      };
    }
  }
};